import {Component, EventEmitter, Input, OnChanges, Output, SimpleChange} from "@angular/core";
import { OwnershipSelectType } from "./ownership-select-type";
import { OwnershipValueType } from "./ownership-value-type";

@Component({
  selector: "ownership-select",
  templateUrl: "./ownership-select.component.html",
})
export class OwnershipSelectComponent implements OnChanges {

  @Input() public disabled: boolean;
  @Input() public selected: string;
  @Input() public type: OwnershipSelectType;
  @Input() public value: OwnershipValueType;
  @Output() public onSave = new EventEmitter();
  public isOpen: boolean = false;
  public selectedBG: string = "bg-success";
  public OwnershipValueType: OwnershipValueType;

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.value && changes.value.currentValue) {
      this.value = changes.value.currentValue;
      this.setSelectedIcon(this.value);
    }
  }

  public getOwnershipValue() {
    return `ownership.${String(this.value).toLowerCase()}`;
  }

  public togglePanel() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
        document.removeEventListener("mousedown", this.togglePanel);
    } else {
        document.addEventListener("mousedown", this.togglePanel);
    }
  }

  public setSelected(strValue: string) {
      const ownershipType: OwnershipValueType = OwnershipValueType[strValue];
      document.removeEventListener("mousedown", this.togglePanel);
      this.setSelectedIcon(ownershipType);
      this.value = ownershipType;
      this.onSave.emit(this.value);
      this.togglePanel();
  }

  private setSelectedIcon(ownershipType: OwnershipValueType) {
    switch (ownershipType) {
      case OwnershipValueType.All:
        this.selectedBG = "bg-success";
        break;
      case OwnershipValueType.None:
        this.selectedBG = "bg-danger";
        break;
      case OwnershipValueType.Custom:
        this.selectedBG = "bg-warning";
        break;
    }
  }

}
